export const BackgroundViewName = {
    stage: "stage",
    meeting: "meeting",
    session: "session",
    appointment: "appointment",
    empty: ""
} as const;

export type BackgroundViewName = typeof BackgroundViewName[keyof typeof BackgroundViewName];